import services from './services';
import {
  lg,
  cloneDeep,
  util,
  isCorrectVal,
  isDate
} from 'utils';
import NProgress from 'nprogress';
import $http from '$http';
export default {
  mixins: [services],
  data() {
    return {
      DialogVisible: false,
      loading: false,
      isReadOnly: false,
      title: "订单详情",
      form: {},
    }
  },
  methods: {
    show(opts) {
      this.DialogVisible = true
      this.getById(opts.OrderId)

    },
    dialogClose() {
      // 查看关闭
      this.DialogVisible = false
    },
  },

}


// WEBPACK FOOTER //
// ./src/pages/Family/NoPayOrderList/viewDialog/vm.js